import { useState, useEffect, useCallback } from "react";
import { Spinner } from "react-bootstrap";
import axios from "axios";


const generatePdf = async (payload) => {


  const response = await axios.post(
    `https://alerp-pdf-service.sirpi.co.in/generate-pdf?type=challan`,
    // `http://localhost:8000/generate-pdf?type=challan`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_PDF_APIKEY}`,
        "Content-Type": "application/json",
      },
      responseType: "blob",
    }
  );

  const blob = new Blob([response.data], { type: "application/pdf" });
  return URL.createObjectURL(blob);
};

const Dialog = ({ show, onClose, challan, type = "outgoing" }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const isOutgoing = type === "outgoing";

  const buildPayload = useCallback(() => {
    if (!challan) return null;

    const payload = {
      type: isOutgoing ? "outgoing" : "incoming",
      challan: {
        project_code: challan.project_code || "",
      },
    };

    if (isOutgoing) {
      payload.challan = {
        ...payload.challan,
        og_ch_no: challan.og_ch_no || "",
        og_ch_date: challan.og_ch_date || "",
        og_from: challan.og_from || "Factory",
        og_source_name: challan.og_source_name || "",
        og_source_address: challan.og_source_address || "",
        og_source_id: challan.og_source_id || "",
        og_to: challan.og_to || "Coaters",
        og_destination_name: challan.og_destination_name || "",
        og_destination_address: challan.og_destination_address || "",
        og_destination_id: challan.og_destination_id || "",
        min_no: challan.min_no || "",
        min_date: challan.min_date || "",
        pin_no: challan.pin_no || "",
        pin_date: challan.pin_date || "",
        og_weight_kg: challan.og_weight_kg || null,
        outgoing_items: (challan.outgoing_items || []).map((item) => ({
          item_code: item.item_code || "",
          alclad_code: item.alclad_code || "",
          item_description: item.item_description || "",
          size: item.size || "",
          quantity: item.quantity || 0,
          og_color_shade: item.og_color_shade || "",
        })),
      };
    } else {
      payload.challan = {
        ...payload.challan,
        ic_ch_no: challan.ic_ch_no || "",
        ic_ch_date: challan.ic_ch_date || "",
        ic_from: challan.ic_from || "Coaters",
        ic_source_name: challan.ic_source_name || "",
        ic_source_address: challan.ic_source_address || "",
        ic_source_id: challan.ic_source_id || "",
        ic_to: challan.ic_to || "Factory",
        ic_destination_name: challan.ic_destination_name || "",
        ic_destination_address: challan.ic_destination_address || "",
        ic_destination_id: challan.ic_destination_id || "",
        ref_og_ch_no: challan.ref_og_ch_no || "",
        remarks: challan.remarks || "",
        incoming_items: (challan.incoming_items || []).map((item) => ({
          item_code: item.item_code || "",
          alclad_code: item.alclad_code || "",
          item_description: item.item_description || "",
          size: item.size || "",
          quantity: item.quantity || 0,
          ic_color_shade: item.ic_color_shade || "",
        })),
      };
    }

    return payload;
  }, [challan, isOutgoing]);

  const fetchPdf = useCallback(async () => {
    try {
      setIsLoading(true);
      setErrorMessage("");
      setPdfUrl((prevUrl) => {
        if (prevUrl) {
          URL.revokeObjectURL(prevUrl);
        }
        return null;
      });

      const payload = buildPayload();
      const url = await generatePdf(payload);
      setPdfUrl(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to generate PDF. Please try again.";
      setErrorMessage(message);
    } finally {
      setIsLoading(false);
    }
  }, [buildPayload]);

  useEffect(() => {
    if (show && challan) {
      fetchPdf();
    }

    return () => {
      setPdfUrl((prev) => {
        if (prev) {
          URL.revokeObjectURL(prev);
        }
        return null;
      });
      setErrorMessage("");
      setIsLoading(true);
    };
  }, [show, challan, fetchPdf]);

  // const handleDownload = () => {
  //   if (!pdfUrl) {
  //     return;
  //   }

  //   const link = document.createElement("a");
  //   link.href = pdfUrl;
  //   link.download = `${
  //     isOutgoing ? "outgoing" : "incoming"
  //   }-challan-${challan[isOutgoing ? "og_ch_no" : "ic_ch_no"] || "challan"}.pdf`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleClose = () => {
    setPdfUrl((prev) => {
      if (prev) {
        URL.revokeObjectURL(prev);
      }
      return null;
    });
    setErrorMessage("");
    setIsLoading(true);
    if (onClose) {
      onClose();
    }
  };

  if (!show || !challan) {
    return null;
  }
                    
                    return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        padding: "24px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#ffffff",
          borderRadius: "12px 12px 0 0",
          padding: "16px 24px",
        }}
      >
        <h5
          style={{
            margin: 0,
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        >
           Preview  {isOutgoing ? "Outgoing" : "Incoming"} Challan
        </h5>
        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
          }}
        >
          {errorMessage && (
            <button
              type="button"
              onClick={fetchPdf}
              disabled={isLoading}
              style={{
                background: "none",
                border: "none",
                color: isLoading ? "#94a3b8" : "#0d6efd",
                textDecoration: "underline",
                cursor: isLoading ? "not-allowed" : "pointer",
                fontWeight: 500,
                padding: 0,
              }}
            >
              Retry
            </button>
          )}

          <button
            type="button"
            onClick={handleClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "1.75rem",
              lineHeight: 1,
              fontWeight: 600,
              color: "#64748b",
              cursor: "pointer",
            }}
            aria-label="Close preview"
          >
            ×
          </button>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          backgroundColor: "#ffffff",
          borderRadius: "0 0 12px 12px",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isLoading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              color: "#475569",
            }}
          >
            <Spinner animation="border" role="status" />
            <span style={{ fontSize: "0.9rem", fontWeight: 500 }}>
              Generating PDF...
            </span>
          </div>
        ) : errorMessage ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: "0 24px",
            }}
          >
            <p style={{ color: "#dc2626", fontWeight: 600, marginBottom: "8px" }}>
              Failed to generate PDF
            </p>
            <p style={{ color: "#64748b", fontSize: "0.9rem" }}>{errorMessage}</p>
          </div>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Dialog;
